import { FC } from "react";
import PrimaryButton from "components/buttons/PrimaryButton";
import SecondaryButton from "components/buttons/SecondaryButton";
import { MicroLabel, StatusBadge } from "../ui";

interface Props {
  nvContactFullName?: string;
  nvContactEmail?: string;
  nvContactPhone?: string;
  onOpenModal: () => void;
}

export const NaturvardsverketContactSection: FC<Props> = ({
  nvContactFullName,
  nvContactEmail,
  nvContactPhone,
  onOpenModal,
}) => {
  // Require the full contact set — name, email and phone are all displayed,
  // so partial/legacy data must count as missing, not "Angiven".
  const hasContact =
    !!nvContactFullName && !!nvContactEmail && !!nvContactPhone;

  return (
    <div className="rounded-xl border border-slate-200 p-4">
      <div className="flex items-center justify-between gap-3">
        <h4 className="text-sm font-semibold text-slate-900">
          Kontaktuppgifter
        </h4>
        <StatusBadge color={hasContact ? "green" : "amber"} dot>
          {hasContact ? "Angiven" : "Saknas"}
        </StatusBadge>
      </div>

      {hasContact ? (
        <div className="mt-4 space-y-3">
          <div className="grid gap-3 sm:grid-cols-3">
            <div>
              <MicroLabel>Kontaktperson</MicroLabel>
              <div className="mt-0.5 text-sm text-slate-900">
                {nvContactFullName}
              </div>
            </div>
            <div>
              <MicroLabel>E-postadress</MicroLabel>
              <div className="mt-0.5 break-all text-sm text-slate-900">
                {nvContactEmail}
              </div>
            </div>
            <div>
              <MicroLabel>Telefonnummer</MicroLabel>
              <div className="mt-0.5 text-sm text-slate-900">
                {nvContactPhone}
              </div>
            </div>
          </div>
          <div className="pt-1">
            <SecondaryButton size="small" onClick={onOpenModal}>
              Uppdatera kontaktuppgifter
            </SecondaryButton>
          </div>
        </div>
      ) : (
        <div className="mt-3 space-y-3">
          <p className="text-sm text-slate-500">
            Kontaktuppgifter har inte angetts än.
          </p>
          <PrimaryButton size="small" onClick={onOpenModal}>
            Ange kontaktuppgifter
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};
